// Follow up to remove: WEB-5827
// @generated by protoc-gen-connect-query v1.4.1 with parameter "target=ts"
// @generated from file conversionproxy/v1/api.proto (package conversionproxy.v1, syntax proto3)

import { MethodKind } from '@bufbuild/protobuf'
import { ProxyRequest, ProxyResponse } from '@universe/api/src/clients/conversionTracking/api_pb'

/**
 * @generated from rpc conversionproxy.v1.ConversionProxyService.Proxy
 */
export const proxy = {
  localName: 'proxy',
  name: 'Proxy',
  kind: MethodKind.Unary,
  I: ProxyRequest,
  O: ProxyResponse,
  service: {
    typeName: 'conversionproxy.v1.ConversionProxyService',
  },
} as const
